import { cn } from '~/utils';

type SelectAllCheckboxProps = Readonly<{
  allSelected: boolean;
  someSelected: boolean;
  onToggle: () => void;
  label: string;
  ariaLabel?: string;
  disabled?: boolean;
  testId: string;
}>;

export function SelectAllCheckbox({
  allSelected,
  someSelected,
  onToggle,
  label,
  ariaLabel,
  disabled = false,
  testId,
}: SelectAllCheckboxProps) {
  return (
    <label
      className={cn(
        'flex w-fit items-center gap-2 text-sm font-medium text-neut-prim',
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      )}
    >
      <input
        type="checkbox"
        className="h-4 w-4 cursor-pointer disabled:cursor-not-allowed"
        checked={allSelected}
        ref={(input) => {
          if (input) {
            input.indeterminate = someSelected;
          }
        }}
        disabled={disabled}
        onChange={onToggle}
        aria-label={ariaLabel}
        data-testid={testId}
      />
      {label}
    </label>
  );
}
